import React, { Component } from 'react';
import SmoothImage from 'react-smooth-image';
import { Form, TextArea, Input, Grid, Button, Image, Segment, Radio, List, GridRow, } from 'semantic-ui-react'
import './SelectionCorp.css';
import docksImage from '../../img/Docks2.jpg'
import { connect } from 'react-redux';
import { authAxios } from '../../utils';
import { UpdateUserURL, GetEmployeeInformationURL, InsertPatchEmployeeAsyncURL, GetDeviceImagesURL } from '../../constants';
import { authContext } from '../../adalConfig';
import Popup from "reactjs-popup";
import CorpHeader from './RHHeader';
import CorpFooter from './RHFooter';
import { translationsV2 } from '../../translations';


let loginNameWithDomain = authContext.getCachedUser() ? authContext.getCachedUser().profile.upn : '';

class CorpHardware extends Component {

    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        //this.handleDockChange = this.handleDockChange.bind(this);
        this.handleLaptopChange = this.handleLaptopChange.bind(this);
        //this.handleYesDock = this.handleYesDock.bind(this);
    }

    state = {
        value: '',
        dock: '',
        error: 'false',
        userRole: '',
        region: '',
        key: '',
        computerDeviceData: [],
        translations: {},
        country: '',
        //dockData: [
        //    { name: 'Dock 1', label: 'Type 1 Dock' },

        //    { name: 'Other', label: 'Other' }
        //]
    }


    getComputerDevicesData(computerdevices) {
        let data = computerdevices.map((x) => {
            return ({
                'name': x.name,
                'display': x.display,
                'processor': x.processor,
                'ram': x.ram,
                'hardDrive': x.hardDrive,
                'ports': x.ports,
                'weight': x.weight,
                'batterylife': x.batterylife,
                'accessories': x.dockingStation,
                'image': x.imageFile ? "data:image/" + x.imageName.split(".")[1] + ";base64, " + x.imageFile : null

            })
        });
        return data;
    }

    getWeigh(wight) {
        if (!wight) return '';
        const weightValue = parseFloat(wight);
        if (this.state.country === 'DE' || this.state.country === 'FR') {
            const kgWaight = (weightValue * 0.453592).toFixed(2);
            return `${kgWaight} kg`;
        } else {
            return `${weightValue} lbs`;
        }
    }

    getComputerImageURL(computerData) {
        var data = "";
        for (var index = 0; index < computerData.length - 1; index++) {
            data = data.concat(computerData[index].image + ',');
        }
        data = data.concat(computerData[computerData.length - 1].image);
        return data;
    }

    componentDidMount() {
        // This method is called when the component is first added to the document
        //this.ensureDataFetched();
        if (!loginNameWithDomain) {
            this.props.history.push('./unauthorized');
            return;
        }
        authAxios.post(GetEmployeeInformationURL, {
            LoginNameWithDomain: loginNameWithDomain
        })
            .then(response => {
                let data = response.data;
                let imageUrls = data.computerDevices.map(_ => _.image);


                authAxios.post(GetDeviceImagesURL, {
                    DeviceNames: imageUrls
                })
                    .then(response1 => {
                        let data1 = response1.data;
                        let newdata = data.computerDevices.map((item, i) => Object.assign({}, item, data1[i]));
                        this.setState({
                            value: data.currentSelectedComputerDevice,
                            //dock: data.currentSelectedDockDevice,
                            userRole: data.userRole,
                            region: data.region,
                            computerDeviceData: this.getComputerDevicesData(newdata),
                            Region: data.Region,
                            country: data.country,
                            key: data.key
                        }, () => {
                            if (this.state.userRole === 'PROTIVITI')
                                this.props.history.push('/selection')
                            else if (this.state.userRole === 'FIELD')
                                this.props.history.push('/selectionfield')

                            this.setState({
                                loading: false
                            })

                        });

                        const country = this.state.country

                        let translations = this.getTranslationsBasedOnCountry(country);
                        if (translations) {
                            this.setState({
                                translations: translations
                            });
                        }

                    }).catch((error) => {
                        console.log('error ' + error);
                        this.setState({
                            errorredirect: true
                        });
                        this.setState({
                            loading: false
                        })
                        this.props.history.push('../unauthorized');
                    })




            })
            .catch((error) => {
                console.log('error ' + error);
                this.setState({
                    errorredirect: true
                });
                this.setState({
                    loading: false
                })
                this.props.history.push('./unauthorized');
            });
    }

    getTranslationsBasedOnCountry(country) {
        const translations = translationsV2.find(t => t.language === country);
        if (translations) {
            return translations.translations;
        }
        return translationsV2.find(t => t.country === "United States").translations;
    }

    handleClick() {
        if ( !this.state.value) {
            this.setState({
                error: 'true'
            })
        }
        else if (!this.state.computerDeviceData.find(_ => _.name === this.state.value)) {
            this.setState({
                error: 'true'
            })
        }
        //else if (this.state.value == 'Other') {
        //    let empDTO = {
        //        CurrentSelectedComputerDevice: this.state.value,
                
        //        upgradeWeek: ''
        //    }
             
        let results = [];
        let empDTO = {
            CurrentSelectedComputerDevice: this.state.value,

                upgradeWeek: ''}
            for (const property in empDTO) {
                results.push({
                    "op": "replace",
                    "path": `${property}`,
                    "value": `${empDTO[property]}`
                })
            }
            authAxios.patch(InsertPatchEmployeeAsyncURL + this.state.key,
                results
            )
                .then(response => {
                    if (this.state.value.includes('Other'))
                        this.props.history.push('./review')
                    else
                        this.props.history.push('./calendar');
                })
                .catch((error) => {
                    console.log('error: ' + error);
                    authContext.login();
                    this.handleClick();

                });
        }


    

    handleLaptopChange(e, value) {
        this.setState({
            value: value.value,
            error: 'false'
        })
    }

   


    userErrorMessage = () => {
        return (
            <React.Fragment>
                {this.state.error === 'true' &&
                    <h2 className="errorreviewUIselect" >
                        Error: You must make a selection for all the required fields.
                    </h2>
                }

            </React.Fragment>
        )
    }


    handleSecondColumn(item) {
        return (
            <React.Fragment>
                <Grid.Column>

                    <Grid columns={2} divided className="detailsselectcorp">
                        <Grid.Row className="rowlight">
                            <Grid.Column>
                                {this.state.translations.csDisplay}
                            </Grid.Column>
                            <Grid.Column className="leftalign">
                                {item.display}
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row className="rowdark">
                            <Grid.Column>
                                {this.state.translations.csProcessor}
                            </Grid.Column>
                            <Grid.Column className="leftalign">
                                {item.processor}
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row className="rowlight">
                            <Grid.Column>
                                {this.state.translations.csRam}
                            </Grid.Column>
                            <Grid.Column className="leftalign">
                                {item.ram}
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row className="rowdark">
                            <Grid.Column>
                                {this.state.translations.csHardDrive}
                            </Grid.Column>
                            <Grid.Column className="leftalign">
                                {item.hardDrive}
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row className="rowlight">
                            <Grid.Column>
                                {this.state.translations.csPorts}
                            </Grid.Column>
                            <Grid.Column className="leftalign">
                                {item.ports}
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row className="rowdark">
                            <Grid.Column>
                                {this.state.translations.csWeight}
                            </Grid.Column>
                            <Grid.Column className="leftalign">
                                {item.weight}
                            </Grid.Column>
                        </Grid.Row>
                        {/*<Grid.Row className="rowlight">*/}
                        {/*    <Grid.Column>*/}
                        {/*        {this.state.translations.csBatteryLife}*/}
                        {/*    </Grid.Column>*/}
                        {/*    <Grid.Column className="leftalign">*/}
                        {/*        {item.batterylife}*/}
                        {/*    </Grid.Column>*/}
                        {/*</Grid.Row>*/}
                    </Grid>

                </Grid.Column>
            </React.Fragment>
        )
    }

    handleHelpClick = async () => {
        this.props.history.push('./help');
    }

    handleClickBack = async () => {
        this.props.history.push('./userinformation');
    }

    handelHelpButton() {
        if (this.state.region === 'NA') {
            return (
                <React.Fragment>
                    <Button className="helpbutton2" onClick={this.handleHelpClick}> Help</Button>
                </React.Fragment>
            )
        }
    }

    handleEmeaEmail() {
        if (this.state.region === 'EMEA' && this.state.country === 'DE') {
            return (
                <a href='mailto:svcemearegsite@roberthalf.net'>Emea Assest Team!</a>
            )
        }
        else if (this.state.region === 'EMEA' && this.state.country === 'FR') {
            return (
                <a href='mailto:svcemearegsite@roberthalf.net'>l'Équipe des Actifs EMEA !</a>
            )
        }
        else {
            return (
                <a href='mailto:svcemearegsite@roberthalf.net'>Emea Assest Team!</a>
            )
        }
    }

    handleNoComputerDevicesAllowedEmea() {
        if (this.state.computerDeviceData.length === 0 && this.state.region === 'EMEA') {
            return (
                <React.Fragment>
                    <h2 className='noDeviceText'>
                        {this.state.translations.csErrorMessage} <br />
                        {this.state.translations.csErrorMessage2} {this.handleEmeaEmail()}<br />
                    </h2>
                </React.Fragment>
            )
        }
    } 

    handleNoComputerDevicesAllowed() {
        if (this.state.computerDeviceData.length === 0 && this.state.region === 'NA') {
            return (
                <React.Fragment>
                    <h2 className='noDeviceText'>
                        You currently have no allowed devices. <br />
                        Please send us an <a href='mailto:svcnacorpupgrades@roberthalf.com'>email!</a>
                    </h2>
                </React.Fragment>
            )
        }
    }

    render() {
        return (
            <div className="outer-container">
                <div className='inner-container'>
                    <CorpHeader />

                    <h1 className="h1SelectCorp">{this.state.translations.csTitle}</h1>
                    <div>
                        {/*<div className='batterywarn'>*/}
                        {/*    {this.state.translations.csBatteryWarning}*/}
                        {/*</div>*/}
                        <div>
                            <h1 style={{ color: "red", fontWeight: "bold", fontStyle: "italic", }} className="selectionremindercorp"><br />{this.state.translations.csSelectionReminder}</h1><br />
                        </div>

                    </div>
                    {this.handleNoComputerDevicesAllowed()}
                    {this.handleNoComputerDevicesAllowedEmea()}
                    <Form required>
                        <Grid columns={2} divided className="selection" >

                            {this.state.computerDeviceData.map((item, index) =>
                                (<Grid.Row className="border">
                                    <Grid.Column className="area">

                                        <Form.Field className=''>
                                            <Radio

                                                className='text'
                                                label={item.name}
                                                name='radioGroupSelectionCorp'
                                                value={item.name}
                                                checked={this.state.value === item.name}
                                                onChange={(e, value) => this.handleLaptopChange(e, value)}
                                            />
                                        </Form.Field>

                                        <Popup
                                            modal
                                            trigger={
                                                <Image src={item.image} className='laptops' />
                                            }
                                            position="center">
                                            <Image src={item.image} className='picturepopup' />
                                        </Popup>

                                    </Grid.Column>

                                    {this.handleSecondColumn(item)}

                                </Grid.Row>))}
                        </Grid>

                    </Form>

                    <div>
                        <br /><Button color="green" className="backbutton2" onClick={this.handleClickBack}>   <i class="left arrow icon"></i>{this.state.translations.buttonBackText}</Button>
                        <Button
                            type="submit"
                            color="green"
                            width="50"
                            className="calnextbutton"
                            onClick={this.handleClick}
                            disabled={!this.state.value}>
                            {this.state.translations.buttonNextText}
                            <i class="right arrow icon"></i>
                        </Button>
                        <br />
                        <br />
                    </div>

                    <div>
                        {this.handelHelpButton()}
                    </div>

                    {this.userErrorMessage()}

                </div>
                <CorpFooter />
            </div>


        );
    }
}

export default connect()(CorpHardware);
